import { ReactComponent as IconClose } from "@/assets/svgs/icon-close.svg";
import classname from 'classnames';
import PropTypes from "prop-types";

const Tag = ({ children, "data-testid": dataTestId, icon, round, bordered, color, theme = 'light', background = 'white', maxHeight, closable, padding = true, onClose, addClass, ...tagProps }) => {

	const presetColor = ['blue', 'green', 'yellow', 'red', 'grey', 'purple', 'white', 'black']

	const presetTheme = ['light', 'dark', 'none']

	const tagOperationalClass = classname(
		addClass,
		{
			'tag': true,
			'tag--round': round,
			'tag--bordered': bordered,
			'tag--padding': padding,
			[`tag--${color}-${theme}-${background}`]: presetColor.includes(color) && presetTheme.includes(theme) && theme && background,
		}
	)

	return (
		<div {...tagProps} data-testid={dataTestId} className={tagOperationalClass}>
			{icon && (
				<div className="tag__left">
					{icon}
				</div>
			)}
			<div className="tag__right">{children}</div>
			{!!closable && (
				<div
					className="tag__close"
					role="button"
					data-testid={dataTestId + '__close'}
					onClick={onClose ? onClose : null}
				>
					<IconClose />
				</div>
			)}
		</div>
	)
}

Tag.propTypes = {
	children: PropTypes.node.isRequired,
	"data-testid": PropTypes.string,
	icon: PropTypes.node,
	round: PropTypes.bool,
	bordered: PropTypes.bool,
	color: PropTypes.string,
	theme: PropTypes.string,
	background: PropTypes.string,
	maxHeight: PropTypes.string,
	closable: PropTypes.bool,
	padding: PropTypes.bool,
	onClose: PropTypes.func,
	addClass: PropTypes.string,
}

export default Tag
